import { render, staticRenderFns } from "./ModernizacaoSistemasBC.vue?vue&type=template&id=3fd8b051&scoped=true"
import script from "./ModernizacaoSistemasBC.vue?vue&type=script&lang=js"
export * from "./ModernizacaoSistemasBC.vue?vue&type=script&lang=js"
import style0 from "./ModernizacaoSistemasBC.vue?vue&type=style&index=0&id=3fd8b051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd8b051",
  null
  
)

export default component.exports